import React, { useState, memo, useMemo } from "react"
import Box from "@material-ui/core/Box"
import clsx from "clsx"
import { makeStyles } from "@material-ui/core/styles"
import Button from "@material-ui/core/Button"
import Typography from "@material-ui/core/Typography"
import { useSelector } from "react-redux"
import ProcessingReviewTable from "@/components/project-dashboard/shared-component/processing-review-table"

const useStyles = makeStyles((theme) => ({
    finalResultOverviewWrapper: {
        padding: theme.spacing(0, 3),
        margin: "0 auto",
        maxWidth: "650px",
    },
    finalResultOverviewTopWrapper: {
        textAlign: "center",
        fontWeight: 600,
        maxWidth: "600px",
        margin: "0 auto",
    },
    finalResultOverviewTopTitle: {
        fontWeight: 600,
    },
    processingBarWrapper: {
        backgroundColor: "#eee",
        borderRadius:"8px",
        height: "30px",
        marginBottom: theme.spacing(0, 3),
        width: "100%",
    },
    processingBar: {
        backgroundColor: theme.palette.success.main,
        borderRadius:"8px",
        height: "100%",
        width: ({ barWidth }) => `${barWidth * 100}%`,
        transition: "all .5s linear",
    },
    bottomButtonWrapper: {
        display: "flex",
        margin: theme.spacing(5, 0, 6),
        justifyContent: "flex-end",
    },
}))

const BulkAddParticipantReview = memo((props) => {
    const { handleClose, participantList, setShowResult, setParticipantFinalListAddParticipant } = props
    const { processedTask, processStatus, processMessage, totalNumber, processResults, processError } = useSelector(
        (state) => state.activateProjectProcessReducer
    )

    const styleProps = {
        barWidth: processStatus === "processing" || processStatus === "done" ? processedTask / totalNumber : 0,
        participantList,
    }
    const classes = useStyles(styleProps)
    const [columns] = useState(() => [
        {
            id: "email",
            label: "Email",
        },
        { id: "status", label: "Status" },
    ])

    const resultTable = useMemo(() => {
        const resultTableArr = []
        if (processStatus === "done" && processResults.length) {
            // only add the first 100 of participant list
            const targetNumber = participantList.length
            for (let index = 0; index < targetNumber; index++) {
                const participant = participantList[index]
                let successStatus = false
                if (processResults[index].status && processResults[index].status === "fulfilled") {
                    successStatus = true
                }
                resultTableArr.push({
                    email: participant.email,
                    successStatus: {
                        status: !!successStatus,
                        statusText: successStatus ? "Success" : "Failed",
                    },
                })
            }
        }
        return resultTableArr
    }, [participantList, processResults])

    return (
        <Box className="modal-content-block" id="final-result-overview">
            <Box className={clsx(classes.finalResultOverviewWrapper, "final-result-review-wrapper")}>
                <Box className={clsx(classes.finalResultOverviewTopWrapper, "final-result-review-top-wrapper")}>
                    <Box mb={3}>
                        <Typography variant="h6" component="h2" className={classes.finalResultOverviewTopTitle} color="textPrimary">
                            Project Deployment Overview
                        </Typography>
                    </Box>
                </Box>
                <Box className={classes.finalResultOverviewContent}>
                    <Box className={classes.processingBarWrapper}>
                        <Box className={classes.processingBar} />
                    </Box>
                    <Box mt={3} mb={3} display="flex" justifyContent="center">
                        <Typography> {processMessage}</Typography>
                    </Box>
                    <Box>{processError && <Typography>Redeployment process has a issue</Typography>}</Box>
                    <Box>
                        {processStatus === "done" && (
                            <Box mt={3}>
                                {processResults.length !== 0 ? (
                                    <ProcessingReviewTable columns={columns} rows={resultTable} />
                                ) : (
                                    <Typography>No Participant</Typography>
                                )}
                            </Box>
                        )}
                    </Box>
                </Box>
                <Box className={classes.bottomButtonWrapper}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            handleClose()
                            setShowResult(false)
                            setParticipantFinalListAddParticipant([])
                        }}
                    >
                        Close
                    </Button>
                </Box>
            </Box>
        </Box>
    )
})

export default BulkAddParticipantReview
